module.exports = __webpack_public_path__ + "img/ping.782a50d8.svg";